import { render, staticRenderFns } from "./goodsGroup.vue?vue&type=template&id=39061ff3&scoped=true&"
import script from "./goodsGroup.vue?vue&type=script&lang=js&"
export * from "./goodsGroup.vue?vue&type=script&lang=js&"
import style0 from "./goodsGroup.vue?vue&type=style&index=0&id=39061ff3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39061ff3",
  null
  
)

export default component.exports